import { Backdrop, CircularProgress } from "@material-ui/core";

function Loader(props) {
  return (
    <Backdrop open={props.loading} style={{ zIndex: 99999 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
export default Loader;
